import styled from 'styled-components';

import { hexToRgba } from '../../../utils/style';
import { Format } from '../../../utils/styles-constants';
import { BaseStyledComponentProps } from '../../../utils/styles-constants';

interface StyledDropTargetProps extends BaseStyledComponentProps {
	canDrop: boolean;
	isLast?: boolean;
}

const StyledDropTarget = styled('div')`
	position: absolute;
	top: ${({ isLast }: StyledDropTargetProps) => isLast ? 'auto' : '-50%'};
	bottom: ${({ isLast }: StyledDropTargetProps) => isLast ? '-52%' : 'auto'};
	left: -3px;
	right: -3px;
	z-index: -1;
	height: 100%;

	${({ canDrop, theme }: StyledDropTargetProps) => canDrop && `
		background: linear-gradient(0deg, transparent 0%, transparent 50%, ${hexToRgba(theme.primary.actionColor, 20)} 50%, transparent 100%);
	`}

	.is-dragging & {
		z-index: 10;
	}

	@media ${Format.SmartphoneLandscape}, ${Format.Tablet}, ${Format.SmallDesktop}, ${Format.MediumDesktop} {
 		top: -3px;
		bottom: -3px;
		left: ${({ isLast }: StyledDropTargetProps) => isLast ? 'calc(50% + 11px)' : '-50%'};
		right: auto;
		width: 100%;
		height: auto;

		${({ canDrop, isLast, theme }: StyledDropTargetProps) => canDrop && `
			background: ${isLast
				? 'none'
				: `linear-gradient(90deg, transparent 0%, transparent 49%, ${hexToRgba(theme.primary.actionColor, 20)} 49%, transparent 75%)`
			};
		`}
	}

	${({ canDrop, theme }: StyledDropTargetProps) => canDrop && `
		&::after {
			content: '';
			position: absolute;
			top: calc(50% - 5px);
			left: 0;
			right: 0;
			height: 6px;
			border-radius: 3px;
			background-color: ${hexToRgba(theme.primary.actionColor, 80)};

			@media ${Format.SmartphoneLandscape}, ${Format.Tablet}, ${Format.SmallDesktop}, ${Format.MediumDesktop} {
				top: 0;
				bottom: 0;
				left: calc(50% - 7px);
				width: 6px;
				height: auto;
			}
		}
	`}
`;

export {
	StyledDropTarget,
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DriveItemList/DropTarget/styles.ts